import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import List from 'components_new/atoms/List'
import ListItem from 'components_new/atoms/List/ListItem'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import ListItemText from 'components_new/atoms/List/ListItemText'

import { useChecklistItems } from './utils'
import { useTranslation } from 'language/translator'

interface ChecklistProps {
  dashboardGroupId: string
  data?: any
  onShowMore?: () => void
}

const Checklist = (props: ChecklistProps) => {
  const { dashboardGroupId, onShowMore } = props

  const showMore = !Boolean(onShowMore)
  const { t } = useTranslation()
  const checklistItems = useChecklistItems(dashboardGroupId)

  return (
    <>
      <Box
        sx={{
          bgcolor: 'success.background',
          color: 'success.contrastText',
          p: showMore ? 4 : 2,
          borderRadius: 2
        }}
      >
        <Text
          color="inherit"
          gutterBottom={true}
          variant={showMore ? 'h4' : 'subtitle1'}
        >
          {t('activity_overview', 'basic_checklist')}
        </Text>
        <Text color="inherit" variant={showMore ? 'body1' : 'body2'}>
          {t('activity_overview', 'basic_checklist_description')}
        </Text>
        <List dense={true} sx={{ py: 2 }}>
          {checklistItems.map((item) => (
            <ListItem
              key={item.title}
              sx={{ opacity: item.value ? 0.5 : 1, px: 0 }}
            >
              <ListItemIcon sx={{ minWidth: showMore ? 48 : 32 }}>
                <Icon
                  name={
                    item.value
                      ? 'CheckBoxOutlined'
                      : 'CheckBoxOutlineBlankOutlined'
                  }
                  sx={{
                    color: 'success.contrastText'
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  color: 'success.contrastText',
                  fontWeight: 'medium',
                  variant: 'body1'
                }}
                secondary={showMore ? item.body : undefined}
                secondaryTypographyProps={{
                  color: 'success.contrastext',
                  variant: 'body1'
                }}
              />
            </ListItem>
          ))}
        </List>
        {onShowMore ? (
          <Button color="primary" onClick={onShowMore} variant="text">
            {t('global', 'show_more')}
          </Button>
        ) : null}
      </Box>
    </>
  )
}

export default Checklist
